import * as BASE from './base';

export function Register(email, name) {

    return BASE.POST('api/register', { email, name });
}

export function ConfirmUser(email, firstName, lastName, className, pin) {

  var data = { email, firstName, lastName, className, pin };
  console.log('API ConfirmUser called with:', data);  
  return BASE.POST('api/confirmuser', data);
}

export function LoadSession(sessionCode) {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, sessionCode });
    }, 1000);
  });
}


export function GetSessionData(sessionCode) {

    return BASE.POST('api/sessiondata', { sessionCode });
}

export function SubmitAnswers({ sessionCode, answers }) {

    console.log('API SubmitAnswers called with:', { sessionCode, answers });

    return BASE.POST('api/submitanswers', { sessionCode, answers });
}